import './CartPage.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button/Button';
import CategoryItem from '../../components/CategoryItem/CategoryItem';
import { useCartContext } from '../../hooks/useCartContext';

const CartPage = () => {
  const { t } = useTranslation();
  const { items, removeItem, clearCart } = useCartContext();
  const navigate = useNavigate();

  return (
    <div className="cart-page">
      <h1 className="cart-page-title">{t('cart.title')}</h1>

      {items.length === 0 ? (
        <div className="cart-empty">
          <span className="material-symbols-outlined cart-empty-icon">shopping_cart</span>
          <p className="cart-empty-text">{t('cart.empty')}</p>
          <NavLink to="/" className="cart-back-btn">{t('cart.browseCatalog')}</NavLink>
        </div>
      ) : (
        <>
          <ul className="cart-grid">
            {items.map((item) => (
              <li key={item.id} className="cart-grid-item" onClick={() => navigate(`/catalog/item/${item.id}`)}>
                <CategoryItem
                  name={item.name}
                  description={item.categoryName}
                  image={item.image}
                  inCart={true}
                  onRemove={() => removeItem(item.id)}
                />
              </li>
            ))}
          </ul>

          <div className="cart-actions">
            <Button variant="primary" className="cart-enquiry-btn" onClick={() => navigate('/contact')}>
              {t('cart.sendEnquiry')}
            </Button>
            <Button variant="icon" subtleDanger className="cart-clear-btn" onClick={clearCart}>
              {t('cart.clearCart')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
